import React from 'react'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemProvider, EditorItemTextField } from './EditorItemProvider'
import { useThankYouNote } from '../ThankYouNoteProvider'
import thankYouNoteMap from './index'
import { useTranslation } from '~/hooks/useTranslation'
import AylaRatingFeedback from '~/components/shared/AylaRatingFeedback'

const ContentEditor = ({ templateIndex }) => {
  const { aylaThankYouNote, documentId, feedbackRating } = useThankYouNote()
  const { thankYouNoteDocument: { thankYouNote } = {} } = useThankYouNote()
  const { t } = useTranslation('Editor.ContentEditor')

  const starDescriptions = t('star_ratings', {
    defaultValue: [
      'Missed the Mark',
      'Needs Improvement',
      'Pretty Good',
      'Really Helpful',
      'Exactly What I Needed',
    ],
  })

  return (
    <div className="flex flex-col">
      <EditorHeading>
        {thankYouNoteMap[templateIndex]} {t('thank_you_note_content')}
      </EditorHeading>
      <p className="pb-4">{t('the_purpose')}</p>
      {!aylaThankYouNote && templateIndex == 0 && (
        <>
          <p className="pb-4">{t('paragraph_one')}</p>
          <p className="pb-4">{t('paragraph_two')}</p>
          <p className="pb-4">{t('paragraph_three')}</p>
          <p className="pb-4">{t('paragraph_four')}</p>
        </>
      )}
      <EditorItemProvider sectionName="thankYouNote" item={thankYouNote}>
        <EditorItemTextField
          label={t('text_field_label')}
          containerClassName="md:col-span-2"
          fieldName="content"
          areaClassName="h-[650px]"
        />
      </EditorItemProvider>
      {aylaThankYouNote && (
        <AylaRatingFeedback
          routes={{
            createFeedback: `/interview/thank_you_note_builder/${documentId}/feedback`,
          }}
          content={documentId}
          title={t('how_helpful')}
          subtitle={t('your_feedback')}
          starDescriptions={starDescriptions}
          className="mt-12"
          feedbackRating={feedbackRating}
        />
      )}
    </div>
  )
}

export default ContentEditor
